export * from './ResponsiveLabel';
